import { EntityMetadata } from '@ngrx/data';
import { HttpResourceUrls } from '@ngrx/data/src/dataservices/http-url-generator';
import { AdaptiveRule } from './adaptive-rule.model';

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const adaptiveRuleEntityMetadata: EntityMetadata<AdaptiveRule> = {
    entityName: 'AdaptiveRule',
    selectId: adaptiveRuleSelectId // .id is used if doing optimistic update
};

export const adaptiveRuleHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : 'servlets/adaptiverules/entity/',
    collectionResourceUrl: 'servlets/adaptiverules/entities/'
};

// tslint:disable-next-line:only-arrow-functions typedef
export function adaptiveRuleSelectId<T extends { ruleName: any }>(adaptiveRule: AdaptiveRule) {
    return  adaptiveRule === undefined ? undefined : adaptiveRule.ruleName;  // .id is used if doing optimistic update
}
